import React, { useContext, useEffect } from 'react';
import { getLabel } from '../../data/labels';
import { useFetchBetBuilderEvents } from '../../data/useFetchBetBuilderEvents';
import Loader from '../../common/Loader';
import MessageInfo from '../../common/MessageInfo';
import PrematchHomeContext from '../../contexts/PrematchHomeContext';
import BetBuilderMatchPreview from './BetBuilderMatchPreview';
import { useUISettingsDispatch } from '../../UISettingsProvider';
import { BetslipContext } from '../../data/betslip/BetslipConf';

function BetBuilderSection(props) {
	const prematchHomeContext = useContext(PrematchHomeContext);
	const betslipContext = useContext(BetslipContext);
	const dispatch = useUISettingsDispatch();
	const [response] = useFetchBetBuilderEvents(props.data, props.tournament, !prematchHomeContext.betBuilderMatch, false);
	
	useEffect(() => {
		response.data && prematchHomeContext.openMatchBetBuilder(null, true);
	}, [props.tournament, response.data]);
	
	
	useEffect(() => {
		// on-unmount
		return () => {
			betslipContext.setBetBuilderMatch(null);
		}
	}, []);
	
	if(!response.data){
		return <Loader isError={response.isError} />
	}
	const betBuilderTournament = response.data;
	
	
	
	function isSelected(match){
		return prematchHomeContext.betBuilderMatch && 
			   prematchHomeContext.betBuilderMatch.pal === match.pal && 
			   prematchHomeContext.betBuilderMatch.avv === match.avv;
	}
	

	function handleClick(match){
		dispatch({ type: 'setFullscreen', isFullScreen: false });
		prematchHomeContext.openMatchBetBuilder(match, false);
		betslipContext.setBetBuilderMatch(match);
	}
	

	
    return <div className="betBuilderMatchPreviewContainer">
	    {betBuilderTournament.events.length > 0 ?
        	betBuilderTournament.events.map((match, index) => {
        		return <BetBuilderMatchPreview onClick={() => handleClick(match)} key={index} betBuilderMatch={match}  selected={isSelected(match)} />
        	})
	        	
	        :
	        <MessageInfo message={getLabel('general.no_events')} />
	    }
   </div>;
}

export default BetBuilderSection;
